export default "__VITE_ASSET__1e7ad3f4__"